import { useMemo } from "react";
import { useSelector } from "react-redux";

const filterHouses = (houses, searchText) => {
	return houses.filter((houseObj) => {
		if (
			!houseObj.building.toLowerCase().includes(searchText) &&
			!houseObj.corpus?.toLowerCase()?.includes(searchText)
		) {
			return false;
		} else {
			return true;
		}
	});
};

const filterStreets = (streets, searchText) => {
	const result = [];
	streets.forEach((streetObj) => {
		if (!streetObj.street.toLowerCase().includes(searchText)) {
			const houses = filterHouses(streetObj.houses, searchText);
			if (houses.length > 0) {
				result.push({
					...streetObj,
					houses,
				});
			}
		} else {
			result.push(streetObj);
		}
	});
	return result;
};

const filterRegions = (regions, searchText) => {
	const result = [];
	regions.forEach((regionObj) => {
		if (!regionObj.region.toLowerCase().includes(searchText)) {
			const streets = filterStreets(regionObj.streets, searchText);
			if (streets.length > 0) {
				result.push({
					...regionObj,
					streets,
				});
			}
		} else {
			if (regionObj.regionId) {
				result.push(regionObj);
			}
		}
	});
	return result;
};

const useSearchedAddresses = (search) => {
	const showContent = useSelector(
		(store) => store.votingStore.addressesModal.showContent
	);
	const showEntity = useSelector(
		(store) => store.votingStore.addressesModal.showEntity
	);
	return useMemo(() => {
		if (!search) {
			return [showContent, showEntity];
		}
		const searchText = search.toLowerCase().trim();
		let result = [];
		if (showEntity === "root") {
			showContent.forEach((companyObj) => {
				if (!companyObj.company.toLowerCase().includes(searchText)) {
					const regions = filterRegions(companyObj.regions, searchText);
					if (regions.length > 0) {
						result.push({
							...companyObj,
							regions,
						});
					}
				} else {
					result.push(companyObj);
				}
			});
		}
		if (showEntity === "regions") {
			const regions = filterRegions(showContent.regions, searchText);
			if (regions.length > 0) {
				result = {
					...showContent,
					regions,
				};
			} else {
				result = {
					...showContent,
					regions: [],
				};
			}
		}
		if (showEntity === "houses") {
			const houses = filterHouses(showContent.houses, searchText);
			if (houses.length > 0) {
				result = {
					...showContent,
					houses,
				};
			} else {
				result = {
					...showContent,
					houses: [],
				};
			}
		}
		return [result, showEntity];
	}, [search, showContent, showEntity]);
};

export default useSearchedAddresses;
